<span class="top-nav-header">
  <div class="left-header">
    <!-- Hamburger menu -->
    <div
      class="hamburger-menu"
      onkeypress="toggleDrawer()"
      (click)="toggleDrawer()"
    >
      <img
        type="image"
        id="hamburger"
        alt="hamburger"
        class="toggle-icon"
        [src]="IMAGES.HAMBURGER"
      />
    </div>

    @if (pageHeader()) {
      <span class="page-header-small">{{ pageHeader() }}</span>
    }

    <!-- App logo/name-->
    <div class="logo-container">
      <img [src]="IMAGES.GPD" class="logo" alt="logo" />
      <span id="text" class="app-name">{{ DISPLAY.APP_NAME }}</span>
      <span id="text" class="app-name-small">{{ DISPLAY.APP_NAME_SMALL }}</span>
    </div>
  </div>

  @if (authService.allowDrawerToggle()) {
    <div class="right-header">
      <!-- Profile Details -->
      <ion-buttons class="button-container">
        <!-- Groups -->
        <ion-button
          id="text"
          class="group-button"
          [matMenuTriggerFor]="groupMenu"
          [disabled]="!canSeeGroups"
          #groupTrigger="matMenuTrigger"
          (menuOpened)="onGroupMenuOpened()"
        >
          <div slot="start" id="button-text">
            {{ DISPLAY.GROUP_TEXT }}:
            {{
              currentLocation == null
                ? DISPLAY.LOADING_TEXT
                : currentLocation.groupCode
            }}
          </div>
          @if (currentLocation && canSeeGroups) {
            <ion-icon
              [src]="IMAGES.ARROW_DOWN"
              class="arrow-down"
              slot="end"
            ></ion-icon>
          }
        </ion-button>

        <mat-menu
          #groupMenu="matMenu"
          yPosition="below"
          (closed)="resetValues()"
        >
          <ng-template matMenuContent>
            <div
              class="menu-search"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              <ion-item
                class="header-custom-search"
                lines="none"
                [class.has-query]="groupSearch"
              >
                <ion-input
                  #groupSearchInput
                  name="groupSearch"
                  class="topnav-group-search-input"
                  maxlength="10"
                  [placeholder]="DISPLAY.SEARCH || 'Search'"
                  [(ngModel)]="groupSearch"
                  [ngModelOptions]="{ standalone: true }"
                ></ion-input>
                <div
                  class="clear-search-text-icons"
                  onkeypress="resetGroupValue()"
                  (click)="resetGroupValue()"
                >
                  <img
                    alt="cancel"
                    [src]="
                      groupSearch.length > 0
                        ? IMAGES.CLEAR_WHITE
                        : IMAGES.SEARCH
                    "
                    [ngClass]="{ 'active-click': groupSearch.length > 0 }"
                  />
                </div>
              </ion-item>
            </div>

            @for (
              group of locationGroups | filterByCode: groupSearch;
              track group
            ) {
              <button
                mat-menu-item
                id="dropdown-button"
                (click)="handleGroupChange(group.code)"
              >
                {{ group.code }}
              </button>
            }
          </ng-template>
        </mat-menu>
        <!----------------------->

        <!-- Sites -->
        <ion-button
          id="text"
          class="location-button"
          [matMenuTriggerFor]="siteMenu"
          [disabled]="!canSeeLocations"
          #siteTrigger="matMenuTrigger"
          (menuOpened)="onSiteMenuOpened()"
        >
          <div slot="start" id="button-text">
            {{ DISPLAY.LOCATION_TEXT }}:
            {{
              currentLocation == null
                ? DISPLAY.LOADING_TEXT
                : currentLocation.location?.locationCode
            }}
          </div>
          @if (currentLocation && canSeeLocations) {
            <ion-icon
              [src]="IMAGES.ARROW_DOWN"
              class="arrow-down"
              slot="end"
            ></ion-icon>
          }
        </ion-button>

        <mat-menu
          #siteMenu="matMenu"
          yPosition="below"
          (closed)="resetValues()"
        >
          <ng-template matMenuContent>
            <div
              class="menu-search"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              <ion-item
                class="header-custom-search"
                lines="none"
                [class.has-query]="siteSearch"
              >
                <ion-input
                  #siteSearchInput
                  name="siteSearch"
                  class="topnav-group-search-input"
                  maxlength="10"
                  [placeholder]="DISPLAY.SEARCH || 'Search'"
                  [(ngModel)]="siteSearch"
                  [ngModelOptions]="{ standalone: true }"
                ></ion-input>
                <div
                  class="clear-search-text-icons"
                  onkeypress="resetSiteValue()"
                  (click)="resetSiteValue()"
                >
                  <img
                    alt="cancel"
                    [src]="
                      siteSearch.length > 0 ? IMAGES.CLEAR_WHITE : IMAGES.SEARCH
                    "
                    [ngClass]="{ 'active-click': siteSearch.length > 0 }"
                  />
                </div>
              </ion-item>
            </div>

            @for (site of linkedSites | filterByCode: siteSearch; track site) {
              <button
                mat-menu-item
                id="dropdown-button"
                (click)="handleLocationChange(site.code)"
              >
                {{ site.code }}
              </button>
            }
          </ng-template>
        </mat-menu>
        <!----------------------->

        <!-- Profile username -->
        <ion-button
          class="profile-name"
          onkeypress="gotoProfile()"
          [disabled]="!canEditProfile"
          (click)="gotoProfile()"
        >
          <ion-icon
            id="profile-icon"
            slot="start"
            [src]="IMAGES.USER_PIN"
          ></ion-icon>
          <div class="user-text" id="text" slot="end">
            {{ userDisplayName() }}
          </div>
        </ion-button>
        <!----------------------->

        <!-- Searchbar -->
        <ion-item
          class="header-custom-searchbar"
          lines="none"
          [class.has-query]="searchQuery"
        >
          @if (!searchQuery) {
            <ion-button slot="start" fill="clear">
              <ion-icon class="search-icon" [src]="IMAGES.SEARCH"></ion-icon>
            </ion-button>
          }
          <ion-input
            name="searchQuery"
            class="topnav-tracking-number-input"
            [placeholder]="DISPLAY.SEARCH_BAR_PLACEHOLDER"
            [maxlength]="18"
            [(ngModel)]="searchQuery"
            [ngModelOptions]="{ standalone: true }"
            (keypress)="pressKey($event)"
          ></ion-input>
          @if (searchQuery) {
            <ion-button
              onkeypress="searchQuery = ''"
              slot="end"
              fill="clear"
              (click)="searchQuery = ''"
            >
              <ion-icon
                slot="icon-only"
                class="close-icon"
                [src]="IMAGES.CLOSE_SVG"
              ></ion-icon>
            </ion-button>
          }
        </ion-item>

        <!-- Small Screen Search -->
        @if (!searchQuery) {
          <ion-button
            class="small-search"
            (click)="openPackageTrackingPopup(null)"
          >
            <ion-icon class="search-icon" [src]="IMAGES.SEARCH"></ion-icon>
          </ion-button>
        }
      </ion-buttons>
    </div>
  }
</span>
